import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { campaign_item_data } from "../../data/campaign_data";
import Auctions_dropdown from "../../components/dropdown/Auctions_dropdown";
import Social_dropdown from "../../components/dropdown/Social_dropdown";
import Collection_items from "../../components/collectrions/Collection_items";
import Image from "next/image";
import Link from "next/link";
import Meta from "../../components/Meta";
import { brand_detail_page, cause_detail_page } from "../../services/landing";
import ProSaleBanner from "../../components/ico-landing/ProSaleBanner";
import Cta from "../../components/cta/cta";
import { useDispatch, useSelector } from "react-redux";
import { setItemsTabIndex } from "../../redux/counterSlice";
import Brand_items from "../../components/brand/Brands_items";
export const baseURL = `${process.env.BASE_URL}/`;

const CausePage = () => {
  const [likesImage, setLikesImage] = useState(false);
  const [campaign, setCampaign] = useState({});
  const [data, setData] = useState([]);
  const [campaignDes, setCampaignDes] = useState(false);
  const [loading, setLoading] = useState(false);
  // An unresolvable or non-APPROVED cause used to leave `data` as its initial
  // `[]`, which is not null, so the hero rendered with `src` literally ending
  // in "undefined". Track the miss explicitly instead.
  const [notFound, setNotFound] = useState(false);
  const router = useRouter();
  const { causeId } = router.query;

  const dispatch = useDispatch();

  // Dispatch the action to update itemsTabIndex
  const handleClick = () => {
    dispatch(setItemsTabIndex(3));
    // setCampaignDes(true);
  };

  useEffect(() => {
    const fetchApi = (myCampaignId) => {
      // getDetails
      if (myCampaignId !== undefined) {
        cause_detail_page(myCampaignId)
          .then((res) => {
            // The endpoint answers 200 with no causeDetails for a cause that
            // is missing, deleted, or not APPROVED. Reading through it would
            // throw on `res?.causeDetails.country` (the optional chain stops
            // at `res`), so bail out into the not-found state first.
            if (!res?.causeDetails) {
              setNotFound(true);
              setLoading(true);
              return;
            }

            let tempArray = [];
            // const inputString = res?.causeDetails.overview.description;
            // Split the string into an array of sentences using the period as the delimiter
            // const sentencesArray = inputString.split(".");
            // const firstSentence = sentencesArray[0].trim();
            setCampaign(res.causeDetails);

            // const dateString = res?.causeDetails.overview.startDate;
            // const endDateString = res?.causeDetails.overview.endDate;

            // const dateObjectStartDate = new Date(dateString);
            // const dateObjectEndDate = new Date(endDateString);

            // const options = {
            //   year: "numeric",
            //   month: "short",
            //   day: "numeric",
            // };
            // const formattedDateStartDate =
            //   dateObjectStartDate.toLocaleDateString("en-US", options);
            // const formattedDateEndDate = dateObjectEndDate.toLocaleDateString(
            //   "en-US",
            //   options
            // );

            const newObj = {
              success: res?.success || {},
              // username: res?.username || {},
              organization: res?.causeDetails || {},
              // assests: res?.assets || {},
              // shortDescription: firstSentence,

              details: [
                {
                  id: "07.2K",
                  detailsNumber: "Country",
                  detailsText: res?.causeDetails.country,
                },

                {
                  id: "22.55",
                  detailsNumber: "Category",
                  detailsText: res?.causeDetails.category,
                },

                {
                  id: ".2K",
                  detailsNumber: "City",
                  detailsText: res?.causeDetails.city,
                },
                {
                  id: "20K",
                  detailsNumber: "Reg. Number",
                  detailsText: res?.causeDetails.registrationNum,
                },
                {
                  id: "30K",
                  detailsNumber: "Country Reg.",
                  detailsText: res?.causeDetails.countryOfRegistration,
                },
              ],
            };
            tempArray.push(newObj);
            // console.log("This is new Obj", newObj.success.identityVerification);
            setData(tempArray[0]);
            // console.log(tempArray);
            setLoading(true);
            // console.log(newObj);
          })
          .catch((err) => {
            console.error("Failed to load cause detail:", err);
            setNotFound(true);
            setLoading(true);
          });
      }
    };
    if (router.isReady) {
      const { causeId } = router.query;
      if (causeId === undefined) return null;
      fetchApi(causeId);
    }
  }, [router.isReady, router.query]);

  useEffect(() => {
    dispatch(setItemsTabIndex(2));
  }, [dispatch]);

  const handleLikes = () => {
    if (!likesImage) {
      setLikesImage(true);
    } else {
      setLikesImage(false);
    }
  };

  return (
    <>
      <Meta title={`${causeId} || Impactoverse | Impact Art Marketplace`} />

      <div className="pt-[5.5rem] lg:pt-24">
        {notFound ? (
          <div className="flex min-h-[50vh] flex-col items-center justify-center px-4 text-center">
            <h1 className="mb-3 text-2xl font-semibold text-jacarta-700 dark:text-white">
              Cause not found
            </h1>
            <p className="mb-6 max-w-md text-jacarta-500 dark:text-jacarta-300">
              This cause doesn&apos;t exist, or it isn&apos;t approved yet. It
              may have been removed or the link may be out of date.
            </p>
            <Link
              href="/causes"
              className="rounded-full bg-accent py-2.5 px-8 text-center font-semibold text-white transition-all hover:bg-accent-dark"
            >
              Browse causes
            </Link>
          </div>
        ) : data?.organization ? (
          <div>
            <div>
              {/* Banner - responsive height */}
              <div className="relative h-[160px] sm:h-[200px] md:h-[250px] lg:h-[300px]">
                <Image
                  src={baseURL + data.organization?.logoUrl}
                  alt="banner"
                  width={1519}
                  height={300}
                  className="w-full h-full object-center object-cover"
                />
                {/* Gradient overlay for better text visibility */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
              </div>

              <section className="dark:bg-jacarta-800 bg-light-base relative pb-8 sm:pb-12 pt-16 sm:pt-20 md:pt-28">
                {/* Avatar - responsive size */}
                <div className="absolute left-1/2 top-0 z-10 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center">
                  <figure className="relative h-24 w-24 sm:h-32 sm:w-32 md:h-40 md:w-40 rounded-xl border-4 sm:border-[5px] border-white dark:border-jacarta-600 shadow-lg">
                    <Image
                      width={141}
                      height={141}
                      src={baseURL + data.organization?.logoUrl}
                      alt={data.shortDescription}
                      className="rounded-xl object-cover h-full w-full"
                    />
                    <div
                      className="dark:border-jacarta-600 bg-green absolute -right-2 sm:-right-3 bottom-0 flex h-5 w-5 sm:h-6 sm:w-6 items-center justify-center rounded-full border-2 border-white"
                      data-tippy-content="Verified Collection"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        className="h-3 w-3 sm:h-[.875rem] sm:w-[.875rem] fill-white"
                      >
                        <path fill="none" d="M0 0h24v24H0z"></path>
                        <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
                      </svg>
                    </div>
                  </figure>
                </div>

                <div className="container px-4 sm:px-6">
                  <div className="text-center">
                    {/* Title - responsive font size */}
                    <h2 className="font-display text-jacarta-700 mb-3 sm:mb-4 text-2xl sm:text-3xl md:text-4xl font-semibold dark:text-white">
                      {data.organization?.name}
                    </h2>

                    {/* Stats Grid - modern mobile-first design */}
                    <div className="mb-6 sm:mb-8 max-w-lg mx-auto">
                      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2 sm:gap-3">
                        {data.details?.map(
                          ({ id, detailsNumber, detailsText }) => (
                            <div
                              key={id}
                              className="dark:bg-jacarta-700 bg-white dark:border-jacarta-600 border-jacarta-100 rounded-xl border p-3 sm:p-4 transition-shadow hover:shadow-md"
                            >
                              <div className="text-accent text-xs sm:text-sm font-semibold uppercase tracking-wide mb-1">
                                {detailsNumber}
                              </div>
                              <div className="text-jacarta-700 dark:text-white text-sm sm:text-base font-medium truncate">
                                {detailsText || "—"}
                              </div>
                            </div>
                          ),
                        )}
                      </div>
                    </div>

                    {/* Description - responsive text */}
                    <p className="dark:text-jacarta-300 text-jacarta-600 text-sm sm:text-base md:text-lg leading-relaxed max-w-2xl mx-auto px-2">
                      {data.organization?.about}
                    </p>

                    {/* Action buttons */}
                    <div className="mt-5 sm:mt-6 flex items-center justify-center gap-2 sm:gap-3">
                      <button
                        className="dark:border-jacarta-600 dark:hover:bg-jacarta-600 border-jacarta-100 hover:bg-jacarta-100 dark:bg-jacarta-700 rounded-xl border bg-white h-10 w-10 sm:h-11 sm:w-11 flex items-center justify-center transition-colors"
                        onClick={() => handleLikes()}
                      >
                        {likesImage ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width={24}
                            height={24}
                            className="h-4 w-4 sm:h-5 sm:w-5 fill-red-500"
                          >
                            <path fill="none" d="M0 0H24V24H0z" />
                            <path d="M12.001 4.529c2.349-2.109 5.979-2.039 8.242.228 2.262 2.268 2.34 5.88.236 8.236l-8.48 8.492-8.478-8.492c-2.104-2.356-2.025-5.974.236-8.236 2.265-2.264 5.888-2.34 8.244-.228z" />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width={24}
                            height={24}
                            className="h-4 w-4 sm:h-5 sm:w-5 fill-jacarta-500 dark:fill-jacarta-200"
                          >
                            <path fill="none" d="M0 0H24V24H0z" />
                            <path d="M12.001 4.529c2.349-2.109 5.979-2.039 8.242.228 2.262 2.268 2.34 5.88.236 8.236l-8.48 8.492-8.478-8.492c-2.104-2.356-2.025-5.974.236-8.236 2.265-2.264 5.888-2.34 8.244-.228zm6.826 1.641c-1.5-1.502-3.92-1.563-5.49-.153l-1.335 1.198-1.336-1.197c-1.575-1.412-3.99-1.35-5.494.154-1.49 1.49-1.565 3.875-.192 5.451L12 18.654l7.02-7.03c1.374-1.577 1.299-3.959-.193-5.454z" />
                          </svg>
                        )}
                      </button>

                      <Social_dropdown />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      {/* <Cta data={data}></Cta> */}
      {/* Nothing to list for a cause that couldn't be resolved — without this
          the not-found message sits above an empty items section. */}
      {!notFound && (
        <section id="section1">
          <Brand_items
            description={""}
            feasibility={""}
            impact={""}
            campaignDes={""}
            isSuperCampaign={""}
            brandUserId={""}
            causeUserId={data?.organization?.userId}
          />
        </section>
      )}
    </>
  );
};

export default CausePage;
